(function(){
    'use strict';
    angular.module('Services').factory('CompaniesTableService', CompaniesTableService);

    CompaniesTableService.$inject = [
        'TableLiteFactory',
        'ClientService',
        'ConfirmationModalFactory',
        '$uibModal',
        '$timeout',
        '$q',
        '$rootScope'
    ];

    function CompaniesTableService(
        TableLiteFactory,
        ClientService,
        ConfirmationModalFactory,
        $uibModal,
        $timeout,
        $q,
        $rootScope
    ) {
        return function(service, form, options = {}) {
            let dataCopy = [];
            let tableStructure = {
                optionAddOns: {
                    url: '/templates/pages/services/add-ons/tableHeader/menu-buttons.html',
                    button: {
                        delete: removeSelected,
                        add: initCompany
                    }
                },
                form: form,
                config: {
                    noFooter: true,
                    noExtraction: true,
                    noTopOptions: false,
                    noPagination: true,
                    tableMinHeight: '15em'
                },
                headers: [
                {
                    width: '1%',
                    class: 'checkAllFilter',
                    viewName: 'checkAll',
                    label: 'Select',
                    filter: {
                        type: 'checkbox'
                    }
                },{
                    width: '15%',
                    label: 'Company',
                    viewName: 'company',
                    class: 'headerLabel'

                },
                {
                    width: '45%',
                    label: 'Offices',
                    viewName: 'offices'
                },
                ],
                data: [],
                onInit:()=>{
                    $timeout(()=>{
                        buildTableData(service.companyOffices || [], true);
                    });
                },
                rowOnClick: initCompany
            };
            let deleteConfirmation = new ConfirmationModalFactory({},{
                message: 'You are about to delete all the selected data.',
                code: 'Do you wish to continue?'
            });
            let formatedOffices = {
                url: '/templates/pages/services/add-ons/tableBody/formatedOffices.html',
                value: null
            };
            let editableCompany = {
                url: '/templates/pages/services/add-ons/tableBody/editableCompany.html',
                value: null
            }
            function buildTableData(item, createCopy){
                if(item){
                    let companies = item.content ? item.content : item;
                    angular.forEach(companies, function(row){
                        row.company = angular.extend(angular.copy(editableCompany), {
                            value: row,
                            valueFormatted: row.name
                        });

                        row.offices = angular.extend(angular.copy(formatedOffices), {
                            value: row.offices ? row.offices : [],
                            valueFormatted: row.offices ? row.offices.map(data => {
                                return data.name;
                            }).join('; ') : 'All Offices Selected'
                        });

                        tableStructure.data.push(row);

                        if(createCopy) {
                            dataCopy.push(row);
                        }
                    });
                }
            }
            function initCompany(company, ngDisabled){
                if(!ngDisabled) {
                    var modalInstance = $uibModal.open({
                        animation: true,
                        ariaLabelledBy: 'modal-title',
                        ariaDescribedBy: 'modal-body',
                        windowClass: 'setting-modal',
                        templateUrl: '/templates/pages/services/add-ons/companyModal.html',
                        controller: 'CompaniesTableModalController',
                        size: 'lg',
                        controllerAs: 'vm',
                        appendTo: $('body'),
                        resolve: {
                            'selectedCompaniesData' : ()=>{
                                return tableStructure.data;
                            },
                            'company' : company
                        }
                    });

                    modalInstance.result.then(function(data){
                        if(data) {
                            updateTableData(data);
                        }
                    });
                }
            }
            function updateTableData(data) {
                let found = false;
                for(let i = 0; i < tableStructure.data.length; i++) {
                    let companyId = tableStructure.data[i].id ?  tableStructure.data[i].id : tableStructure.data[i].company.value.id;
                    if(companyId == data.selectedCompany.id) {
                        tableStructure.data[i].offices = angular.extend(angular.copy(formatedOffices), {
                            value: data.offices ? data.offices : [],
                            valueFormatted: data.offices.length ? data.offices.map(data => {
                                return data.name;
                            }).join('; ') : 'All Offices Selected'
                        });
                        found = true;
                    }
                }
                if(!found) {
                    let newCompany = {
                        company: angular.extend(angular.copy(editableCompany), {
                            value: data.selectedCompany,
                            valueFormatted: data.selectedCompany.name
                        }),
                        offices: angular.extend(angular.copy(formatedOffices), {
                            value: data.offices ? data.offices : [],
                            valueFormatted: data.offices.length ? data.offices.map(data => {
                                return data.name;
                            }).join('; ') : 'All Offices Selected'
                        })
                    }
                    tableStructure.data.push(newCompany);
                }
                $rootScope.$broadcast('companiesTableUpdated', 'updated');
            }
            function removeSelected() {
                let selectedData = tableStructure.data.filter(value=>{return value.isSelected});
                if(selectedData.length !== 0) {
                    deleteConfirmation.getInstance().result.then(function(cond){
                        if(cond){
                            let newData = tableStructure.data.filter(value=>{
                                return !value.isSelected;
                            });
                            tableStructure.data = newData;
                        }
                        $rootScope.$broadcast('companiesTableUpdated', 'updated');
                    });
                }
            }
            function noData() {
                return tableStructure.data.length <= 0 ? true : false;
            }
            function resetTableData() {
                tableStructure.data.length = 0;
                angular.forEach(dataCopy, data=>tableStructure.data.push(data));
            }
            this.updateTable = buildTableData;
            this.resetTableData = resetTableData;
            this.noData = noData;
            this.tableData = tableStructure;
        }
    }
})()



// WEBPACK FOOTER //
// ./js/services/tables/CompaniesTableService.js